export default __webpack_public_path__ + "static/media/CLICK_HERE.4888a653.gif";